const MAX_WIDTH = 500
const MAX_HEIGHT = 500

// Full quality jpegs use about 8.25 bits per pixel.
// (500 pixels * 500 pixels) * 8.25 bits per pixel = 2,062,500 bits
// 2,062,500 bits / 8 bits per byte / 1024 bytes per kilobyte = 252 kilobytes
// Data URLs are roughly 37% larger than the original unencoded size.
// 252 kilobytes * 1.37 = 345.24 kilobytes
// The API will reject any data URL larger than 1mb. This is because we have 8 images to store,
// and documents in MongoDB can't be larger than 16mb.

export default function dataURLFromImage(file) {
  return new Promise(resolve => {
    const url = window.URL.createObjectURL(file)
    const img = new Image()
    
    img.onload = () => {
      const scalingFactor = Math.min((MAX_WIDTH / img.width), (MAX_HEIGHT / img.height))
      const newWidth = img.width * scalingFactor
      const newHeight = img.height * scalingFactor
      const canvas = document.createElement('canvas')
      canvas.width = newWidth
      canvas.height = newHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, newWidth, newHeight)
      window.URL.revokeObjectURL(url)
      resolve(canvas.toDataURL('image/jpeg', 1.0))
    }

    img.src = url
  })
}



// WEBPACK FOOTER //
// ./src/utils/dataURLFromImage.js